import React from "react";
import type Contact from "@/model/interface/Contact";
import { getContactDisplayName } from "@/util/string";
import MessageThread from "@/components/pages/messages/MessageThread";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";

interface LeadHistorySheetProps {
  contact: Contact | undefined;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function LeadHistorySheet({ contact, open, onOpenChange }: LeadHistorySheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="flex w-full flex-col gap-0 p-0 sm:max-w-xl">
        <SheetHeader className="border-b border-border px-5 py-4">
          <SheetTitle>{(contact && getContactDisplayName(contact)) ?? "Lead"}</SheetTitle>
          <SheetDescription>Calls, texts, voicemails and notes. Texts you send here go to the Inbox thread.</SheetDescription>
        </SheetHeader>
        <div className="flex min-h-0 flex-1 flex-col">
          {contact && open && <MessageThread contact={contact} showFromBar />}
        </div>
      </SheetContent>
    </Sheet>
  );
}
